<template>
  <vx-card :title="$t('Analytics.ImpressionsComparison')">
    <template slot="actions">
      <feather-icon
        icon="SettingsIcon"
        svgClasses="w-6 h-6 text-grey"
      ></feather-icon>
    </template>
    <div slot="no-body" class="p-6 pb-0">
      <div class="flex" v-if="!isLoading">
        <div class="mr-6">
          <p class="mb-1 font-semibold">{{$t("Analytics.ThisMonth")}}</p>
          <p class="text-3xl text-success">
            {{ statisticsData.summary.currentMonth.toLocaleString() }}
          </p>
        </div>
        <div>
          <p class="mb-1 font-semibold">{{$t("Analytics.LastMonth")}}</p>
          <p class="text-3xl">
            {{ statisticsData.summary.previousMonth.toLocaleString() }}
          </p>
        </div>
      </div>
      <vue-apex-charts
        type="line"
        height="266"
        :options="chartOptions"
        :series="statisticsData.series"
      />
    </div>
  </vx-card>
</template>

<script>
import { mapGetters } from 'vuex'
import VueApexCharts from "vue-apexcharts"

export default {
  data () {
    return {
      chartOptions: {
        chart: {
          toolbar: { show: false },
          dropShadow: {
            enabled: true,
            top: 5,
            left: 0,
            blur: 4,
            opacity: 0.10
          }
        },
        stroke: {
          curve: "smooth",
          dashArray: [0, 8],
          width: [4, 2]
        },
        grid: {
          borderColor: "#e7e7e7"
        },
        legend: {
          show: false
        },
        colors: ["#F97794", "#b8c2cc"],
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            inverseColors: false,
            gradientToColors: ["#7367F0", "#b8c2cc"],
            shadeIntensity: 1,
            type: "horizontal",
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100, 100, 100]
          }
        },
        markers: {
          size: 0,
          hover: {
            size: 5
          }
        },
        xaxis: {
          labels: {
            style: {
              cssClass: "text-grey fill-current"
            }
          },
          axisTicks: {
            show: false
          },
          categories: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31"],
          axisBorder: {
            show: false
          }
        },
        yaxis: {
          tickAmount: 5,
          labels: {
            style: {
              cssClass: "text-grey fill-current"
            },
            formatter (val) {
              return val > 999 ? `${(val / 1000).toFixed(1)}k` : val
            }
          }
        },
        tooltip: {
          x: { show: false }
        }
      }
    }
  },
  components: {
    VueApexCharts
  },
  created () {
    this.refreshData()
  },
  methods: {
    refreshData () {
      const payload = {
        idCampaign: this.activeCampaignId,
        retailBranchId: this.activeStrategy ? this.activeStrategy.retailBranchId : null,
        startDate: this.$store.state.statistics.monthComparison.range.start,
        endDate: this.$store.state.statistics.monthComparison.range.end,
        dimension: "Date",
      }
      this.$store.dispatch("statistics/fetchStatisticsMonthComparison", payload)
    }
  },
  computed: {
    ...mapGetters([
      "activeOrganisation",
      "activeCampaign",
      "activeStrategy"
    ]),
    activeCampaignId () {
      return this.$store.state.AppActiveUser.activeCampaignId
    },
    activeStrategyId () {
      return this.$store.state.AppActiveUser.activeStrategyId
    },
    isLoading: function () {
      return this.$store.state.statistics.monthComparison.isLoading
    },
    statisticsData: function () {
      const mc = this.$store.state.statistics.monthComparison
      return {
        summary: {
          currentMonth: mc.currentMonth.data.reduce((a, b) => a + b.impressions, 0),
          previousMonth: mc.previousMonth.data.reduce((a, b) => a + b.impressions, 0)
        },
        series: [
          {
            name: mc.currentMonth.name,
            data: mc.currentMonth.data.map(item => {
              return item.impressions
            })
          },
          {
            name: mc.previousMonth.name,
            data: mc.previousMonth.data.map(item => {
              return item.impressions
            })
          }
        ]
      }
    }
  },
  watch: {
    activeCampaignId: function () {
      this.refreshData()
    },
    activeStrategyId: function () {
      this.refreshData()
    }

  },
}
</script>